module.exports = __webpack_public_path__ + "media/images/expert__kathrin-lehmann@3x-d904f749fe34332b178a1f6fdd670cc7.png";